import { useState } from "react";
import { MessageCircle, Flag, Ban } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { useChat } from "@/context/ChatContext";
import { useAuth } from "@/context/AuthContext";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { ReportDialog } from "@/components/chat/ReportDialog";
import { toast } from "sonner";

export function UserActionMenu({ targetId, username, children }) {
  const { openDm } = useChat();
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [reportOpen, setReportOpen] = useState(false);

  const requestChat = async () => {
    try {
      const { data } = await api.post("/dm/request", { to_user_id: targetId });
      if (data.status === "exists" || data.status === "accepted") {
        openDm(data.conversation_id);
        toast.success(`${username} ile sohbet açıldı.`);
      } else if (data.status === "pending") {
        toast.info("İsteğin zaten bekliyor. Onaylanınca haber vereceğiz.");
      } else {
        toast.success(`${username} kullanıcısına sohbet isteği gönderildi.`);
      }
      setOpen(false);
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  const chatBan = async () => {
    if (!window.confirm(`${username} sohbetten banlansın mı?`)) return;
    try {
      await api.post(`/admin/users/${targetId}/chat-ban`, { chat_banned: true });
      toast.success(`${username} sohbetten banlandı.`);
      setOpen(false);
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  return (
    <>
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <button data-testid="chat-username-button" className="hover:underline underline-offset-2">{children}</button>
        </PopoverTrigger>
        <PopoverContent align="start" className="w-56 p-2 bg-slate-950/95 backdrop-blur-xl border-slate-800 text-slate-100">
          <p className="text-xs text-slate-500 px-2 py-1 truncate">@{username}</p>
          <button data-testid="request-chat-button" onClick={requestChat} className="w-full h-9 rounded-lg px-2 text-sm text-left hover:bg-slate-800 inline-flex items-center gap-2 text-cyan-200 transition-colors">
            <MessageCircle className="h-4 w-4" /> Sohbet Et
          </button>
          <button data-testid="report-user-button" onClick={() => { setOpen(false); setReportOpen(true); }} className="w-full h-9 rounded-lg px-2 text-sm text-left hover:bg-slate-800 inline-flex items-center gap-2 text-red-300 transition-colors">
            <Flag className="h-4 w-4" /> Bildir (Report)
          </button>
          {user?.role === "admin" && (
            <button data-testid="chat-ban-user-button" onClick={chatBan} className="w-full h-9 rounded-lg px-2 text-sm text-left hover:bg-red-950 inline-flex items-center gap-2 text-red-400 font-semibold transition-colors border-t border-slate-800 mt-1 pt-1">
              <Ban className="h-4 w-4" /> Sohbetten Banla
            </button>
          )}
        </PopoverContent>
      </Popover>
      <ReportDialog open={reportOpen} onOpenChange={setReportOpen} targetId={targetId} username={username} />
    </>
  );
}
